import { Services, regExp } from '@sigma-frontend-libs/commons'

import { billingsSources, components } from '@/utils'

import tag from '@/components/tag'

function renderAmountField(h) {
  let suffix = null
  if (this.$_currency) {
    suffix = this.getTranslate(`currency.${this.$_currency}.symbol.unicode`)
  }

  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.amount,
        label: this.getTranslate(`${Services.billings}.labels.amount`),
        suffix,
        dense: true,
        required: this.required,
        clearable: true,
        autofocus: true,
        details: false,
        mask: regExp.negativeNumber,
        processValue: value => {
          return value?.toString().replace(',', '.')
        }
      },
      on: {
        input: event => {
          this.proxy.amount = event
        }
      }
    }
  )
}
function renderSourceField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.source,
        label: this.getTranslate(`${Services.billings}.labels.source`),
        items: Object.values(billingsSources).map(value => {
          return {
            title: this.getTranslate(`${Services.billings}.sources.${value}`),
            iconSVG: value,
            iconColor: value,
            value
          }
        }),
        dense: true,
        required: this.required,
        details: false
      },
      on: {
        input: event => {
          this.proxy.source = event
        }
      },
      scopedSlots: {
        selection: ({ item }) => {
          return h(
            tag,
            {
              props: {
                label: item.title,
                color: item.value,
                as: 'select-dense'
              }
            }
          )
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.billings}-form--basic`
    },
    [
      renderAmountField.call(this, h),
      renderSourceField.call(this, h)
    ]
  )
}
